

export default function Benefit3() {
	return (
		<>

			<div className="tf-widget-benefit-v3">
				<div className="themeflat-container">
					<div className="tf-benefit-v3">
						<div className="benefit-item-v3 wow zoomIn animated" data-wow-delay="0.1s">
							<i className="icon-phone-call" />
							<h6>24/7 Customer Service</h6>
							<p>We're here to help you with any questions or concerns you have, 24/7.</p>
						</div>
						<div className="benefit-item-v3 wow zoomIn animated" data-wow-delay="0.3s">
							<i className="icon-Return1" />
							<h6>14-Day Money Back</h6>
							<p>If you're not satisfied with your purchase, simply return it within 14 days for a refund.</p>
						</div>
						<div className="benefit-item-v3 wow zoomIn animated" data-wow-delay="0.5s">
							<i className="icon-guarantee" />
							<h6>Our Guarantee</h6>
							<p>We stand behind our products and services and guarantee your satisfaction.</p>
						</div>
						<div className="benefit-item-v3 wow zoomIn animated" data-wow-delay="0.7s">
							<i className="icon-delivery-truck-11" />
							<h6>Shipping worldwide</h6>
							<p>We ship our products worldwide, making them accessible to customers everywhere.</p>
						</div>
					</div>
				</div>
			</div>
		</>
	)
}
